import * as Yup from 'yup';

export const candidateSchema = Yup.object().shape({
  dateOfBirth: Yup.string().required('Veuillez renseigner une date de naissance'),
  birthName: Yup.string().required('Veuillez renseigner votre nom de naissance'),
  placeOfBirth: Yup.string().required('Veuillez renseigner une ville de naissance'),
  birthCountry: Yup.string().required('Veuillez renseigner votre pays de naissance'),
  nationality: Yup.string().required('Veuillez renseigner une nationalité'),
  address: Yup.string().required('Veuillez renseigner une adresse'),
  zipCode: Yup.string()
    .matches(/[0-9]{5}/, 'Le code postal doit être composé de 5 chiffres')
    .required('Veuillez renseigner un code postal'),
  city: Yup.string().required('Veuillez renseigner une ville'),
  fatherName: Yup.string().required('Veuillez renseigner le nom de famille de votre père'),
  fatherFirstname: Yup.string().required('Veuillez renseigner le prénom de votre père'),
  motherName: Yup.string().required('Veuillez renseigner le nom de famille de votre mère'),
  motherFirstname: Yup.string().required('Veuillez renseigner le prénom de votre mère'),
  trainingMonth: Yup.string().required('Veuillez renseigner la date de formation'),
  offerChoice: Yup.number().required('Veuillez choisir un contrat'),
});
